define('jquery',["jquery", "jquery.svgdom"], function ($) {
	/// <param name="$" value="jQuery" />
	"use strict";

	var hidingClasses = ["ng-hide", "collapse", "hide", "hidden", "hidden-xs", "hidden-sm", "hidden-md", "hidden-lg", "visible-xs", "visible-sm", "visible-md", "visible-lg" ,"visible-xs-block", "visible-xs-inline", "visible-xs-inline-block", "visible-sm-block", "visible-sm-inline", "visible-sm-inline-block", "visible-md-block", "visible-md-inline", "visible-md-inline-block", "visible-lg-block", "visible-lg-inline", "visible-lg-inline-block" ];
	var hidingClassesSelector = (hidingClasses.length ? "." : "") + hidingClasses.join(", .");
	var hidingClassesRemover = hidingClasses.join(" ");

	function wrapFunctionWithTempShow($context, fn) {
		function show() {
			if ($context.is(":visible")) {
				// The element is already visible, don't do anything.
				return function () { };
			}
			var $parents = $context.parents();
			var elementCss = [];
			$parents.each(function () {
				var $this = $(this);
				var saved = false;
				var restoreThis = {
					$element: $this,
					attrs: {}
				};

				function saveAttr(attrName) {
					restoreThis.attrs[attrName] = $this.attr(attrName);
					saved = true;
				}
				if ($this.is(hidingClassesSelector)) {
					saveAttr("class");
					$this.removeClass(hidingClassesRemover);
				}
				if ($this.css("display") === "none") {
					saveAttr("style");
					$this.show();
				}
				
				if (saved) {
					elementCss.push(restoreThis);
				}
			});

			return function restore() {
				$.each(elementCss, function () {
					var $element = this.$element;
					if (this.attrs) {
						$.each(this.attrs, function (key, value) {
							if (value || typeof value === typeof "") {
								$element.attr(key, value)
							}
							else {
								$element.removeAttr(key);
							}
						});
					}
				});
			}
		}

		return function wrappedFunction() {
			var restore = show();
			var result = fn.apply($context, arguments);
			restore();
			return result;
		}
	}

	function wrapElementActual($this) {
		function elementActualWrapper(fn) {
			return wrapFunctionWithTempShow($this, fn)();
		}
		for (var prop in $this) {
			(function (prop) {
				var propDescriptor = Object.getOwnPropertyDescriptor(this, prop);
				if (propDescriptor && !propDescriptor.configurable) {
					return;
				}

				if ($this.hasOwnProperty(prop)) {
					if (!isNaN(prop)) {
						this[+prop] = $this[prop];
						return;
					}
				}
			
				Object.defineProperty(this, prop, {
					enumerable: true,
					get: function () {
						var value = $this[prop];
						if ($.isFunction(value)) {
							return wrapFunctionWithTempShow($this, value);
						}
						else {
							return value;
						}
					}
				});
			}).call(elementActualWrapper, prop);
		}

		return elementActualWrapper;
	}

	Object.defineProperties($.fn, {
		actual: {
			enumerable: false,
			configurable: true,
			get: function () {
				return wrapElementActual(this);
			}
		}
	});
	//$.extend($.fn, {
	//	actual: function (delegate) {

	//	}
	//});
	return $;
});
